export enum InputWithLabelType {
  checkbox = 'checkbox',
  toggleSwitch = 'toggleSwitch'
}
